module.exports = __webpack_public_path__ + "img/2_248.e5652e8b.png";